<template>
    <div class="flex justify-center items-start min-h-screen p-4 sm:p-6" 
    :style="{ backgroundColor: localCompany.colorpage || '#D3D3D3' }">
    <div class="bg-white shadow-lg rounded-lg p-4 w-full max-w-sm sm:max-w-md md:max-w-lg text-center">
        
        <!-- Logo -->
        <div class="logo-container">
          <img
            v-if="localCompany.logofilename"
            :src="`${apiBaseUrl}/static/logos/${localCompany.logofilename}`"
            alt="Logo da Empresa"
            class="w-40 h-auto mx-auto"
          />
        </div>

        <!-- Nome da empresa -->
        <h1
          v-if="localCompany && localCompany.hide_name === false"
          class="text-gray-700 font-semibold text-xl sm:text-2xl md:text-3xl mb-8 text-center"
        >
          {{ localCompany.name }}
        </h1>
        
        
        
        
        <h1 class="text-2xl font-semibold text-gray-800 mb-4  mt-8">Obrigado por Confiar em Nosso Trabalho!</h1>
        <p class="text-gray-600 mb-8 text-lg">
          Se puder, avalie-nos no Google com 5 estrelas e um comentário. É rápido e nos ajuda a crescer! 🙏🌟🌟🌟🌟🌟
        </p>

        <!-- Botão de Enviar -->
        <div class="flex justify-center mt-6">
          <button
            @click="gotoGoogle"
            class="text-white font-semibold rounded-lg text-base px-4 py-2 hover:opacity-90 sm:text-lg sm:px-6"
            :style="{ backgroundColor: this.localCompany.colorbutton || '#0A66C2' }"
          >
            Clique para Avaliar
          </button>
        </div>

        <p class="text-gray-600 mt-12">
          Redirecionando para o Formulário do Google em {{ countdown }} segundos...
        </p>

        
      </div>
    </div>
  </template>
  
  <script>
  import { useCompanyStore } from '@/stores/company';
  // import { sanitizeText, sanitizeUrl, validateColor, sanitizeFilename } from '@/utils/security';
  import { sanitizeUrl } from '@/utils/security';
  export default {
    props: {
      link: {
        type: String,
        required: true,
      },
      // company: {
      //   type: Object,
      //   required: true,
      // }
    },
    data() {
      return {
        countdown: 5,
        apiBaseUrl: process.env.VUE_APP_API_URL, // Define a URL base como parte do estado
        //localCompany: null, // Adicionamos uma variável local
      };
    },
    computed: {
        localCompany() {
          const companyStore = useCompanyStore();
          return companyStore.tempCompany;
        },
    },
    created() {
        // Inicializa localCompany com uma cópia do objeto company
        //this.localCompany = this.company ? { ...this.company } : {};
        ///console.log ("this.localCompany: ", this.localCompany);

        console.log(">>>> this.company 379: ", this.localCompany);
        console.log ("this.localCompany.colorpage: 89",this.localCompany.colorpage);


    },
    mounted() {
      if (!this.link) {
        console.error('Erro: redirectLink não foi fornecido.');
        this.$router.push('/'); // Redirecione para uma rota padrão ou mostre uma mensagem
        return; 
      }
      this.startCountdown();
    },
    methods: {
      startCountdown() {
        const interval = setInterval(() => {
          this.countdown -= 1;
          if (this.countdown <= 0) {
            clearInterval(interval);
            window.location.href = this.link;
          }
        }, 1000);
      },
      gotoGoogle(){
        window.location.href = sanitizeUrl(this.link);
      }
    },
  };
  </script>
  
  <style scoped>
  /* Adiciona um pouco mais de espaçamento lateral */
  .bg-white {
    padding-left: 20px;
    padding-right: 20px;
  }
  </style>